import Tooltip from "@material-ui/core/Tooltip";
import { withStyles } from "@material-ui/core/styles";

const BigTooltip = withStyles(() => ({
    tooltip: {
        fontSize: "0.875rem",
        padding: "8px 10px",
        lineHeight: 1.35,
        maxWidth: 360,
        backgroundColor: "#616161",
        color: "#fff",
        boxShadow: "0 4px 14px rgba(0,0,0,0.18)",
    },
    arrow: {
        color: "#616161",
    },
}))(Tooltip);

export default BigTooltip;
